import { render } from "./TvmFlowEndItems.vue?vue&type=template&id=5a6bd02c"
import script from "./TvmFlowEndItems.vue?vue&type=script&lang=js"
export * from "./TvmFlowEndItems.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/Components/ChatWidget/TvmFlowEndItems/TvmFlowEndItems.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5a6bd02c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5a6bd02c', __exports__)) {
    api.reload('5a6bd02c', __exports__)
  }
  
  module.hot.accept("./TvmFlowEndItems.vue?vue&type=template&id=5a6bd02c", () => {
    api.rerender('5a6bd02c', render)
  })

}


export default __exports__